import { render, staticRenderFns } from "./DashboardCommerceChart.vue?vue&type=template&id=c85630f0&scoped=true"
import script from "./DashboardCommerceChart.vue?vue&type=script&lang=js"
export * from "./DashboardCommerceChart.vue?vue&type=script&lang=js"
import style0 from "./DashboardCommerceChart.vue?vue&type=style&index=0&id=c85630f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c85630f0",
  null
  
)

export default component.exports